// src/components/ArticleCard.js
import React from 'react';
import { Link } from 'react-router-dom';

// In src/components/ArticleCard.js - update the date badge and card class
// In src/components/ArticleCard.js - update the date badge and card class
function ArticleCard({ article }) {
  return (
    <div className="article-card group"> {/* Changed from 'card' to 'article-card' */}
      <div className="flex justify-between items-start mb-4">
        <span className="date-badge"> {/* Added date-badge class */}
          {new Date(article.created_at).toLocaleDateString('en-US', { 
            year: 'numeric', 
            month: 'short', 
            day: 'numeric' 
          })}
        </span>
        {article.calculator_name && (
          <span className="calculator-tag group-hover:scale-105 transition-transform duration-300">
            🧮 Includes Calculator
          </span>
        )}
      </div>
      
      <h3 className="text-2xl font-bold text-slate-800 mb-4 group-hover:text-orange-500 transition-colors duration-300 leading-tight dark:text-slate-200 dark:group-hover:text-orange-400">
        {article.title}
      </h3>
      
      <p className="text-slate-600 mb-6 leading-relaxed line-clamp-3 dark:text-slate-200">
        {article.meta_description}
      </p>
      {/*className="inline-flex items-center text-blue-800 hover:text-blue-700 font-semibold group-hover:translate-x-2 transition-all duration-300 dark:text-blue-800 dark:hover:text-blue-8500"*/}
      <Link 
        to={`/articles/${article.slug}`}
        className="inline-flex items-center text-slate-800 group-hover:text-orange-600 font-semibold group-hover:translate-x-2 transition-all duration-300 dark:text-slate-200 dark:group-hover:text-orange-500"
      >
        Read Article
        <svg className="w-5 h-5 ml-2 group-hover:scale-110 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
        </svg>
      </Link>
    </div>
  );
}
export default ArticleCard; 